var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useFormState } from '../hooks';
/**
 * 用来展示错误信息，当你单独使用 FieldWrapper 时可以使用此 API 展示错误信息。
 * 内部其实是调用了 useFormState 订阅了表单节点的 error 状态。
 *
 * 如果它没法满足你的自定义要求，你也可以通过 useFormState 订阅 error 状态，非常方便的自己实现一个类似的组件。
 */
export var ErrorText = function (_a) {
    var form = _a.form, style = _a.style, className = _a.className, disableDefaultStyle = _a.disableDefaultStyle;
    var error = useFormState(form, 'error');
    if (!error || !error.help || error.help.length === 0) {
        return null;
    }
    var help = error.help;
    return (React.createElement("div", { style: __assign(__assign({}, (disableDefaultStyle
            ? {}
            : {
                fontSize: '12px',
                fontWeight: 400,
                color: '#ff4050',
                lineHeight: '16px',
                marginTop: '4px',
            })), style), className: [className].join(' ') }, help.map(function (text, index) { return (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement("div", { key: index },
        help.length > 1 ? index + 1 + ". " : '',
        text)); })));
};
